import { useSyncExternalStore } from 'react';

import {
   getDataLayerEventsSnapshot,
   subscribeToDataLayerEvents,
} from '#helper/data-layer-diagnostics-store';

const EMPTY_SNAPSHOT = Object.freeze([]);

const getServerSnapshot = () => EMPTY_SNAPSHOT;

// Newest-first dataLayer events for the current tab session, e.g.
// [{ event: 'add_to_cart', timestamp: 1719000000000, payload: {...} }].
const useDataLayerEvents = () =>
   useSyncExternalStore(subscribeToDataLayerEvents, getDataLayerEventsSnapshot, getServerSnapshot);

export default useDataLayerEvents;
